/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';

import { Button } from 'react-bootstrap';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@material-ui/core/Radio';
import _ from 'lodash';
import RadioGroup from '@material-ui/core/RadioGroup';
import { Grid, TextField, Select } from '@material-ui/core';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';
import SVGComponent from '../../../SharedModules/SVGComponents/SVGComponents';

import {
  dispatchErrorMsgPaymentSummary,
  getDramsInvStartQtr,
  getPlanTypeValues,
  getRebateProgrameList,
  dispatchReportOption,
  dispatchTimePeriod,
  dispatchRebateProgramName,
  dispatchFromPayment,
  dispatchToPayment,
  dispatchPerformResolutionObj,
  getStateFiscalYear,
  dispatchYear,
  getPaymentSummary,
  dispatchDates,
  dispatchDisplayObjPayment,
} from './Store/action';
import {
  autoFormateDate,
  tabHighLigther,
  validateDateQuarter,
} from '../../../SharedModules/utilities/utilities';
import {
  compareDate,
  convertStringDate,
  quarterToDate,
} from '../../../SharedModules/utilities/dateUtilities';
import RadioGroupComponent from '../../../SharedModules/RadioGroup/RadioGroupBtn';

import {
  STATUS_MSG,
  SUCCESS_MSG,
  REBATE_PROGRAM_REQUIRED,
  FROM_DATE_PAYMENT,
  DATE_QTR_FORMAT_ERROR,
  FROM_DATE_FORMAT_ERROR,
  END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT,
  BEGIN_DATE_QTR_REQUIRED,
  TO_DATE_QTR_REQUIRED,
} from '../../../SharedModules/Errors/constantMessageData';
import { clearReduxForFilterAndSort } from '../../../SharedModules/Table/store/Actions';
import {
  convertDateToQuatre,
  handleScrollToEvent,
} from '../../../SharedModules/CommonUtilities/commonUtilities';

const PaymentSummary = (props) => {
  const {
    performResolutionObj: requestCurrentDisData,
    planType: planTypeList,
    rebateProgram: getRebateProgramList,
    rebateProgramName: getRebateProgramName,
    errorMsgPaymentSummary: getErrorMsg,
    selectedOption: selectedOptionValue,
    quarterFrom: quarterFromValue,
    quarterTo: quarterToValue,
    selectedYear: selectedYearValue,
    QuarterOption: quarterOptionValue,
  } = useSelector((state) => state.sharedState.PaymentSummaryReducer);

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const getStateFiscalListData = useSelector(
    (state) => state?.sharedState?.PaymentSummaryReducer?.stateFiscal
  );
  const getDRAMSListData = useSelector(
    (state) => state?.sharedState?.PaymentSummaryReducer?.dramsInvoice
  );
  const getPaymentSummaryListData = useSelector(
    (state) => state?.sharedState?.PaymentSummaryReducer?.paymentSummary
  );
  const defaultReportQuarter =
    userDefaults?.defRptQtrSelectCd === 'D'
      ? 'DRAMS Invoice Start Quarter'
      : 'All';
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = useState(false);
  const [rebateProgramList, setRebateProgramList] = useState([]);
  const [stateFiscalData, setStateFiscalData] = useState([]);
  const [dramsData, setDramsData] = useState([]);
  const [radioList, setRadioList] = useState([]);
  const [isSearchClicked, setSearchClicked] = useState(false);
  const [selectedOption, setSelectedOption] = useState(selectedOptionValue);
  const [from, setfrom] = useState(quarterFromValue);
  const [to, setto] = useState(quarterToValue);
  const [selectedYear, setSelectedYear] = useState(selectedYearValue);
  const [QuarterOption, setQuarterOption] = useState(
    quarterOptionValue || defaultReportQuarter
  );
  // local variable
  const [state, setState] = useState(
    requestCurrentDisData?.state
      ? requestCurrentDisData?.state
      : {
          planTypeCd: userDefaults?.planTypeCd
            ? userDefaults?.planTypeCd
            : 'FD',
          rebateProgramCd: userDefaults?.rebateProgramCd
            ? getRebateProgramName?.rebateProgramCd ||
              userDefaults?.rebateProgramCd
            : '-1',
          from: '',
          to: '',
        }
  );
  // dispatch function
  const setPerformBalScrData = (value) =>
    dispatch(dispatchPerformResolutionObj(value));

  // Plan type useEffect
  React.useEffect(() => {
    handleScrollToEvent();
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getPlanTypeValues({}));
    }
  }, []);
  const rebatepgmDropdown = async (planType) => {
    const getRebateProgramList = await dispatch(
      getRebateProgrameList(planType)
    );
    let list = [];
    if (
      getRebateProgramList?.status === STATUS_MSG &&
      getRebateProgramList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getRebateProgramList.data)) {
        list = _.map(getRebateProgramList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  };
  //  setting radioList from planList Api
  React.useEffect(() => {
    if (
      planTypeList &&
      planTypeList.PLAN_TYPE_CD &&
      planTypeList.PLAN_TYPE_CD.length > 0
    ) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);
  // get rebate program
  React.useEffect(() => {
    rebatepgmDropdown(state.planTypeCd);
  }, [state.planTypeCd]);

  // handling highlight tab
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther('/paymentSummary', true);
    } else {
      tabHighLigther('/paymentSummary', false);
    }
  }, [getErrorMsg]);

  // on change event on filed
  const handleOnChangeEvent = (value, name) => {
    let localErr = getErrorMsg || [];
    localErr = localErr.filter((item) => item.field != 'noData');
    if (name === 'planTypeCd') {
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      setPerformBalScrData({
        state: { ...state, [name]: value, rebateProgramCd: '-1' },
      });
    }
    if (name === 'rebateProgramCd') {
      setState({ ...state, [name]: value });
      setPerformBalScrData({
        state: { ...state, [name]: value },
      });
    }
    localErr = localErr.filter((item) => item.field != 'rebateProgramCd');
    if (name === 'rebateProgramCd' && value === '-1') {
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }
    dispatch(dispatchErrorMsgPaymentSummary([...new Set(localErr)]));
  };

  // on blur functionality on field level

  const handleOnblurEvent = (type, value) => {
    let localErr = getErrorMsg || [];
    localErr = localErr.filter((item) => item.field != 'noData');
    if (type === 'rebateProgramCd') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
    }

    let fromError = [];
    let toError = [];
    if (type === 'fromDate') {
      if (!value)
        fromError.push({
          field: 'fromDate',
          message: BEGIN_DATE_QTR_REQUIRED,
        });
      if (value) {
        const value1 = autoFormateDate(value);
        setfrom(value1.toUpperCase());
        fromError = validateDateQuarter(value1, 'fromDate');
        if (!to && !fromError.length) {
          setto(value1.toUpperCase());
          localErr = localErr.filter((item) => item.field !== 'toDate');
        }
      }
      localErr = [...localErr, ...fromError];
    }
    if (type === 'toDate') {
      if (!value)
        toError.push({
          field: 'toDate',
          message: TO_DATE_QTR_REQUIRED,
        });
      const value1 = autoFormateDate(value);

      setto(value1.toUpperCase());
      if (value1.length > 0) {
        toError = validateDateQuarter(value1, 'toDate');
      }

      localErr = [...localErr, ...toError];
    }
    if (fromError.length === 0 && toError.length === 0) {
      let frmDt, toDt;
      if (type === 'fromDate' && value) frmDt = autoFormateDate(value);
      else frmDt = from;
      if (type === 'toDate' && value) toDt = autoFormateDate(value);
      else toDt = to;
      if (compareDate(frmDt, toDt)) {
        localErr.push({
          field: 'fromDate>toDate',
          message: END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT,
        });
      }
    }

    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgPaymentSummary(unique));
  };
  // handing full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  const handleChange = (event) => {
    if (selectedOption == 'Payment Date Range') {
      setfrom('');
      setto('');
    }

    setSelectedOption(event.target.value);
    let localErr = getErrorMsg || [];
    localErr = localErr.filter(
      (item) => item.field !== 'fromDate' && item.field !== 'toDate' && item.field !== 'noData'
    );
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgPaymentSummary(unique));
  };

  const handlefromChange = (e) => {
    const value = e.target.value.toUpperCase();

    setfrom(value.toUpperCase());
    let localErr = getErrorMsg || [];
    localErr = localErr.filter((item) => item.field !== 'fromDate');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgPaymentSummary(unique));
  };

  const handletoChange = (event) => {
    const value = event.target.value.toUpperCase();

    setto(value);
    let localErr = getErrorMsg || [];
    localErr = localErr.filter((item) => item.field !== 'fromDate>toDate');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgPaymentSummary(unique));
  };

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  const handleQuarterOptionChange = (event) => {
    setQuarterOption(event.target.value);
  };
  const rebateProgramName = rebateProgramList.find(
    (item) => item.id == state.rebateProgramCd
  );
  // state fiscal api
  useEffect(() => {
    if (rebateProgramName?.rebateProgramCd) {
      // drams api
      dispatch(
        getDramsInvStartQtr({
          rebateProgCode: rebateProgramName?.rebateProgramCd,
          allRpc: 0,
        })
      );
      dispatch(
        getStateFiscalYear({
          rebateProgramCd: rebateProgramName?.rebateProgramCd,
        })
      );
    }
  }, [rebateProgramName]);

  useEffect(() => {
    setStateFiscalData(getStateFiscalListData?.statefiscalQtrVO?.stateFiscal);
  }, [getStateFiscalListData]);

  useEffect(() => {
    setDramsData(getDRAMSListData?.dramsInvoiceStartQuarter);
  }, [getDRAMSListData]);

  // extracting year from DRAMS API
  const dateYear = dramsData; // 1Q2021
  const reqYear = dateYear?.toString().slice(-4);
  const federalBeginDateDRAMS = `10/01/${reqYear} `;
  const calenderBeginDateDRAMS = `01/01/${reqYear}`;
  const federalToDateDRAMS = `12/31/${reqYear}`;
  const federalQuarterDRAMS = `4Q${reqYear}`;
  const stateQuarterDRAMS = `${stateFiscalData}Q${reqYear}`;

  const getYearFromDrams = (dramsData) => {
    if (!dramsData) return '';
    return dramsData.toString().slice(-4);
  };

  const getQuarterFromDrams = (dramsData) => {
    if (!dramsData) return '';
    const quarter = dramsData.toString().charAt(0);
    return quarter;
  };

  // Always returns 01/01/{year}
  const getDisplayBeginDateForFiscal = (dramsData) => {
    const year = getYearFromDrams(dramsData);
    return year ? `01/01/${year}` : '';
  };

  // calculate API begin date for State Fiscal
  // const getApiBeginDateForStateFiscal = (dramsData) => {
  //   const year = getYearFromDrams(dramsData);
  //   const quarter = getQuarterFromDrams(dramsData);
  //   const fiscalQuarter = getQuarterFromDrams(stateQuarterDRAMS);
  //   if (!year || !quarter) return '';
    
  //   const monthMap = {
  //     '1': '01',
  //     '2': '04',
  //     '3': '07',
  //     '4': '10'
  //   };
    
  //   const month = monthMap[fiscalQuarter] || '01';
  //   const prevYear = String(parseInt(year) - 1);
  //   return `${month}/01/${prevYear}`;
  // };

  const getApiBeginDateForStateFiscal = (dramsData) => {
    const year = getYearFromDrams(dramsData);
    const quarter = getQuarterFromDrams(dramsData);
    if (!year || !quarter) return '';
    
    const monthMap = {
      '1': '01',
      '2': '04',
      '3': '07',
      '4': '10'
    };
    
    const month = monthMap[quarter] || '01';
    return `${month}/01/${year}`;
  };

  // function to calculate API begin date for Federal Fiscal
  const getApiBeginDateForFederalFiscal = (dramsData) => {
    const year = getYearFromDrams(dramsData);
    if (!year) return '';
    const prevYear = String(parseInt(year) - 1);
    return `01/01/${year}`;
  };

  // mQyyy to mm/dd/yyyy
  function convertDateString(dateString) {
    const quarter = parseInt(dateString.charAt(0));
    const year = parseInt(dateString.slice(-4));

    const month = (quarter - 1) * 3 + 1;
    const day = 1;

    const formattedMonth = String(month).padStart(2, '0');
    const formattedDay = String(day).padStart(2, '0');

    return `${formattedMonth}/${formattedDay}/${year}`;
  }
  let stateBeginDateDRAMS = '';
  let beginDate = '';
  if (dramsData && dramsData.length > 0) {
    stateBeginDateDRAMS = convertDateString(stateQuarterDRAMS);
    beginDate = convertDateString(dramsData);
  }
  function formatDate(date) {
    if (date.match(/^\dQ\d{4}$/)) {
      const month = date.charAt(0).padStart(2, '0');
      const year = date.slice(2);
      return `${month}/01/${year}`;
    }
    return date;
  }
  const payDateBegin = formatDate(from);
  // on click of search button
  const click = () => {
    let localErr = getErrorMsg || [];
    if (state.rebateProgramCd === '-1') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }
    let fromError = [];
    if (!from)
      fromError = [{ field: 'fromDate', message: BEGIN_DATE_QTR_REQUIRED }];
    else fromError = validateDateQuarter(from, 'fromDate');
    let toError = [];
    if (!to) toError = [{ field: 'toDate', message: TO_DATE_QTR_REQUIRED }];
    else toError = validateDateQuarter(to, 'toDate');

    if (fromError.length === 0 && toError.length === 0) {
      if (compareDate(from, to)) {
        localErr.push({
          field: 'fromDate>toDate',
          message: END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT,
        });
      }
    }
    if (selectedOption == 'Payment Date Range') {
      localErr = [...localErr, ...fromError, ...toError];
    }

    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgPaymentSummary(unique));
    if (localErr.length == 0) {
      // current date
      function getCurrentDate() {
        const currentDate = new Date();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const year = currentDate.getFullYear();

        return `${month}/${day}/${year}`;
      }

      const currentDate1 = getCurrentDate();
      function formatDate(date, type) {
        if (date.match(/^\dQ\d{4}$/)) {
          const formattedDate = convertStringDate(quarterToDate(date, type));
          // const month = date.charAt(0).padStart(2, '0');
          // const year = date.slice(2);
          // return `${month}/01/${year}`;
          return formattedDate;
        }
        return date;
      }
      const payDateBegin = formatDate(from, 'fromDate');
      const payDateEnd =
        to == '' ? formatDate(from, 'fromDate') : formatDate(to, 'toDate');
      if (!to) {
        setto(from);
      }
      // quarterFromValue;
      const timeTypeObject = {
        Calender: 'C',
        Quarter: 'Q',
        'Payment Date Range': 'P',
        'Federal Fiscal': 'F',
        'State Fiscal': 'S',
      };
      const dateRange = {
        'DRAMS Invoice Start Quarter': {
          beginDate:
            selectedOption == 'Quarter'
              ? convertDateString(dramsData)
              : selectedOption == 'Year' && selectedYear == 'Federal Fiscal'
              ? getApiBeginDateForFederalFiscal(dramsData)
              : selectedOption === 'Year' && selectedYear === 'State Fiscal'
              ? getApiBeginDateForStateFiscal(dramsData)
              : calenderBeginDateDRAMS,

          endDate: currentDate1,
          qtr:
            selectedOption == 'Year' && selectedYear == 'Federal Fiscal'
              ? '4' //federalQuarterDRAMS
              : selectedOption === 'Year' && selectedYear === 'State Fiscal'
              ? stateFiscalData //stateQuarterDRAMS
              : dramsData,
          // Add display begin date for header
          displayBeginDate:
            selectedOption == 'Year' && selectedYear == 'Federal Fiscal'
              ? getDisplayBeginDateForFiscal(dramsData)
              : selectedOption === 'Year' && selectedYear === 'State Fiscal'
              ? getDisplayBeginDateForFiscal(dramsData)
              : null,
        },
        All: {
          beginDate:
            selectedOption == 'Year' && selectedYear == 'Federal Fiscal'
              ? '10/01/1991'
              : selectedOption === 'Year' && selectedYear === 'State Fiscal'
              ? convertDateString(`${stateFiscalData}Q1991`)
              : '01/01/1991',
          endDate: currentDate1,
          qtr:
            selectedOption == 'Year' && selectedYear == 'Federal Fiscal'
              ? '4' //'4Q1991'
              : selectedOption === 'Year' && selectedYear === 'State Fiscal'
              ? stateFiscalData //`${stateFiscalData}Q1991`
              : '1Q1991',
        },
      };
      setSearchClicked(true);
      dispatch(
        getPaymentSummary({
          asTimeType:
            selectedOption !== 'Year'
              ? timeTypeObject[selectedOption]
              : timeTypeObject[selectedYear],
          fiscalYearBeginDt:
            selectedOption === 'Payment Date Range'
              ? payDateBegin
              : dateRange[QuarterOption].beginDate,
          fiscalYearEndDt:
            selectedOption === 'Payment Date Range'
              ? payDateEnd
              : dateRange[QuarterOption].endDate,
          asQtr:
            selectedOption == 'Payment Date Range'
              ? convertDateToQuatre(payDateEnd)
              : dateRange[QuarterOption].qtr,
          asRpc: rebateProgramName?.rebateProgramCd,
        })
      );

      dispatch(dispatchRebateProgramName(rebateProgramName));
      dispatch(dispatchFromPayment(from));
      dispatch(dispatchToPayment(to));
      dispatch(dispatchReportOption(QuarterOption)); // /drams or all //report option
      dispatch(dispatchTimePeriod(selectedOption)); // payment , quarter, year //time period
      dispatch(dispatchYear(selectedYear)); // calender, state

      dispatch(
        dispatchDates({ 
          beginDate, 
          federalBeginDateDRAMS, 
          stateBeginDateDRAMS,
          displayBeginDateForFiscal: dateRange[QuarterOption]?.displayBeginDate || null
        })
      );
      dispatch(
        dispatchDisplayObjPayment({
          rebateProgramName,
          quarterFrom: from,
          quarterTo: to,
          QuarterOption,
          selectedOption,
          selectedYear,
          beginDate,
          federalBeginDateDRAMS,
          stateBeginDateDRAMS,
          displayBeginDateForFiscal: dateRange[QuarterOption]?.displayBeginDate || null,
        })
      );

      // props.history.push({
      //   pathname: '/displaypaymentsummary',
      // });
    }
  };
  if (isSearchClicked && getPaymentSummaryListData?.data?.length > 0) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/displaypaymentsummary',
      value: 'Display Payment Summary Report',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    props.history.push({
      pathname: '/displaypaymentsummary',
    });
    dispatch(clearReduxForFilterAndSort('/displaypaymentsummary'));
  }

  // let errorMessages = getErrorMsg.map((error) => {
  //   if (error.field == 'fromDate') {
  //     if (from.length === 0) {
  //       return { ...error, message: FROM_DATE_PAYMENT };
  //     }
  //     return { ...error, message: FROM_DATE_FORMAT_ERROR };
  //   }
  //   return error;
  // });
  // errorMessages = [...new Set(getErrorMsg?.map((obj) => obj.message))];
  return (
    <>
      <div className='tabs-container'>
        <Spinner load={spinnerLoader} />
        <CustomSeparator parent1='Summary Reports' parent2='Payment Summary' />
        <DisplayErrorMessages
          errorMessages={[...new Set(getErrorMsg?.map((obj) => obj.message))]}
        />

        <div className='tab-body'>
          {!fullScreenView && (
            <>
              <div className='row'>
                <div className='col-4 frr-two-col-radio'>
                  <RadioGroupComponent
                    data-testid='radio-button-for-rcdd'
                    id='radio-button-for-rcdd_id'
                    labelName='Plan Type'
                    required
                    optionList={radioList || []}
                    defaultValue={state && state.planTypeCd}
                    filterAction={(e) => {
                      handleOnChangeEvent(e, 'planTypeCd');
                    }}
                    className='log-batch-filter-radio frr-checkInvoiceRadio'
                  />
                </div>

                <div className='col-4'>
                  <fieldset className='custom-fieldset'>
                    <legend className='same-font-family'>
                      Rebate Program <span className='mandatory'> *</span>{' '}
                    </legend>
                    <div className='form-wrapper p-0'>
                      <div className='mui-custom-form with-select field-xl no-lbl'>
                        <TextField
                          className='mandate-fields'
                          data-testid='rebate_program-ia'
                          id='rebate_program'
                          label='rebate_program'
                          fullWidth
                          select
                          required
                          placeholder=''
                          inputProps={{ maxLength: 11, id: 'rebate_program' }}
                          onBlur={(e) =>
                            handleOnblurEvent('rebateProgramCd', e.target.value)
                          }
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={state && state.rebateProgramCd}
                          onChange={(e) =>
                            handleOnChangeEvent(
                              e.target.value,
                              'rebateProgramCd'
                            )
                          }
                          helperText={
                            getErrorMsg?.length > 0
                              ? [
                                  ...new Set(
                                    getErrorMsg
                                      ?.filter((x) => {
                                        return x.field === 'rebateProgramCd';
                                      })
                                      .map((item) => {
                                        return item.message;
                                      })
                                  ),
                                ]
                              : null
                          }
                          error={
                            getErrorMsg?.length > 0 &&
                            getErrorMsg?.filter((x) => {
                              return x.field === 'rebateProgramCd';
                            }).length > 0
                              ? [
                                  ...new Set(
                                    getErrorMsg
                                      ?.filter((x) => {
                                        return x.field === 'rebateProgramCd';
                                      })
                                      .map((item) => {
                                        return item.message;
                                      })
                                  ),
                                ]
                              : false
                          }
                        >
                          <MenuItem
                            key=''
                            value='-1'
                            className='frr-dropdown-blank-item'
                          />
                          {rebateProgramList?.length > 0
                            ? rebateProgramList.map((item) => {
                                return (
                                  <MenuItem key={item.id} value={item.id}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </TextField>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div className='col-sm-4'>
                  <fieldset
                    className='custom-fieldset'
                    id='demo-row-radio-buttons-group-label1'
                    style={{
                      background:
                        selectedOption == 'Payment Date Range' ? '#F4F4F4' : '',
                    }}
                    disabled={selectedOption == 'Payment Date Range'}
                  >
                    <legend
                      className='same-font-family'
                      htmlFor='demo-row-radio-buttons-group-label1'
                    >
                      Report Quarter Option{' '}
                      <span className='mandatory'> *</span>{' '}
                    </legend>
                    <div className='form-wrapper p-0'>
                      <div className='mui-custom-form with-select field-xl no-lbl'>
                        <RadioGroup
                          row
                          name='report-quarter'
                          id='reportQuarterOption'
                          required
                          defaultValue={QuarterOption}
                          onChange={handleQuarterOptionChange}
                        >
                          <FormControlLabel
                            style={{ marginRight: '10px' }}
                            value='DRAMS Invoice Start Quarter'
                            control={<Radio />}
                            label='DRAMS Invoice Start Quarter'
                          />
                          <FormControlLabel
                            style={{ marginRight: '10px' }}
                            value='All'
                            control={<Radio />}
                            label='All'
                          />
                        </RadioGroup>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div className='col-sm-12'>
                  <fieldset className='custom-fieldset'>
                    <legend className='same-font-family'>
                      Time Period <span className='mandatory'> *</span>{' '}
                    </legend>
                    <div className='form-wrapper p-0 mt-2'>
                      <div className='mui-custom-form input-md field-xl'>
                        <div className='sub-radio no-margin'>
                          <RadioGroup
                            row
                            name='time-period'
                            value={selectedOption}
                            onChange={handleChange}
                          >
                            <div className='col-sm-4'>
                              <FormControlLabel
                                value='Payment Date Range'
                                control={<Radio />}
                                label='Payment Date / Quarter Range'
                                data-test='Payment Date Range'
                              />
                              <Grid container spacing={2}>
                                <Grid item xs={6} className='mandate-fields'>
                                  <TextField
                                    label='Begin'
                                    id='Begin'
                                    placeholder=''
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    inputProps={{ maxLength: 10 }}
                                    name='From'
                                    value={from}
                                    onChange={handlefromChange}
                                    onBlur={(e) => {
                                      handleOnblurEvent(
                                        'fromDate',
                                        e.target.value
                                      );
                                    }}
                                    disabled={
                                      selectedOption !== 'Payment Date Range'
                                    }
                                    helperText={
                                      getErrorMsg?.length > 0
                                        ? [
                                            ...new Set(
                                              getErrorMsg
                                                ?.filter((x) => {
                                                  return x.field === 'fromDate';
                                                })
                                                .map((item) => {
                                                  return item.message;
                                                })
                                            ),
                                          ]
                                        : null
                                    }
                                    error={
                                      getErrorMsg?.length &&
                                      getErrorMsg?.filter((x) => {
                                        return (
                                          x.field === 'fromDate' ||
                                          x.field === 'fromDate>toDate'
                                        );
                                      }).length
                                        ? true
                                        : false
                                    }
                                  />
                                </Grid>
                                <Grid item xs={6} className='mandate-fields'>
                                  <TextField
                                    label='End'
                                    id='End'
                                    placeholder=''
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    value={to}
                                    inputProps={{ maxLength: 10 }}
                                    name='to'
                                    onChange={handletoChange}
                                    onBlur={(e) =>
                                      handleOnblurEvent(
                                        'toDate',
                                        e.target.value
                                      )
                                    }
                                    disabled={
                                      selectedOption !== 'Payment Date Range'
                                    }
                                    helperText={
                                      getErrorMsg?.length > 0
                                        ? [
                                            ...new Set(
                                              getErrorMsg
                                                ?.filter((x) => {
                                                  return (
                                                    x.field === 'toDate' ||
                                                    x.field ===
                                                      'fromDate>toDate'
                                                  );
                                                })
                                                .map((item) => {
                                                  return item.message;
                                                })
                                            ),
                                          ]
                                        : null
                                    }
                                    error={
                                      getErrorMsg?.length &&
                                      getErrorMsg?.filter((x) => {
                                        return (
                                          x.field === 'toDate' ||
                                          x.field === 'fromDate>toDate'
                                        );
                                      }).length
                                        ? true
                                        : false
                                    }
                                  />
                                </Grid>
                              </Grid>
                            </div>

                            <div className='col-sm-2'>
                              <FormControlLabel
                                value='Quarter'
                                control={<Radio />}
                                label='Quarter'
                                data-test='Quarter'
                              />
                            </div>
                            <div className='col-sm-6'>
                              {' '}
                              <FormControlLabel
                                value='Year'
                                control={<Radio />}
                                label='Year'
                                data-test='Year'
                              />
                              <div className='mui-custom-form input-md override-width-50'>
                                <div className='col-10 mb-3'>
                                  <TextField
                                    style={{
                                      marginTop: '-65px',
                                      marginLeft: '62px',
                                    }}
                                    select
                                    id='Calender'
                                    label='Calender'
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    InputProps={{ id: 'Calender' }}
                                    value={selectedYear}
                                    onChange={handleYearChange}
                                    disabled={selectedOption !== 'Year'}
                                  >
                                    <MenuItem
                                      selected
                                      key='Please Select One'
                                      value='Calender'
                                    >
                                      Calender
                                    </MenuItem>
                                    <MenuItem
                                      selected
                                      key='Please Select One'
                                      value='Federal Fiscal'
                                    >
                                      Federal Fiscal
                                    </MenuItem>
                                    <MenuItem
                                      selected
                                      key='Please Select One'
                                      value='State Fiscal'
                                    >
                                      State Fiscal
                                    </MenuItem>
                                  </TextField>
                                </div>
                              </div>
                            </div>
                          </RadioGroup>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
              <div className='col-sm-12'>
                <div className='btn-wrapper mb-2'>
                  <div className='float-right mt-2 hide-on-print'>
                    <Button
                      className='btn btn-success btn-search'
                      data-testid='view_detail_ia'
                      type='button'
                      // onClick={display}
                      onClick={click}
                    >
                      {' '}
                      <SVGComponent iconName='Icon-search' /> {'  '} Search
                    </Button>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default PaymentSummary;
